import React, { useState, useMemo } from 'react';
import './Style/AllUsers.css';
import TopNavbar from '../home/TopNavbar';
import Loading from '../home/Loading';
import UseStudentMessages from './UseStudentContact';

const StudentMessage = () => {

    const { messages, loading } = UseStudentMessages();

    // Search
    const [searchTerm, setSearchTerm] = useState('');

    // Items per page
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // Current page
    const [currentPage, setCurrentPage] = useState(1);


    /* =========================================
       Count Messages By Type
    ========================================= */

    const typeCounts = useMemo(() => {

        if (!messages) {
            return {};
        }

        return messages.reduce((acc, item) => {

            if (item.type) {

                acc[item.type] =
                    (acc[item.type] || 0) + 1;

            }

            return acc;

        }, {});

    }, [messages]);


    /* =========================================
       Convert Date To IST
    ========================================= */

  const toIST = (dateString) => {
    if (!dateString) return 'Loading...';
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };


    /* =========================================
       Search / Filter
    ========================================= */

    const filteredMessages = useMemo(() => {

        if (!messages) {
            return [];
        }

        const search =
            searchTerm
                .toLowerCase()
                .trim();

        // No search
        if (!search) {
            return messages;
        }

        return messages.filter((item) => {

            return [

                item.id,
                item.name,
                item.phone,
                item.email,
                item.type,
                item.subject,
                item.message,
                item.date

            ]
                .filter(
                    value =>
                        value !== null &&
                        value !== undefined
                )
                .some(value =>
                    String(value)
                        .toLowerCase()
                        .includes(search)
                );

        });

    }, [messages, searchTerm]);


    /* =========================================
       Loading
    ========================================= */

    if (loading) {
        return <Loading />;
    }


    /* =========================================
       Pagination
    ========================================= */

    const totalPages =
        itemsPerPage === 'all'
            ? 1
            : Math.ceil(
                filteredMessages.length /
                Number(itemsPerPage)
            );


    const startIndex =
        itemsPerPage === 'all'
            ? 0
            : (currentPage - 1) *
            Number(itemsPerPage);


    const displayedMessages =
        itemsPerPage === 'all'
            ? filteredMessages
            : filteredMessages.slice(
                startIndex,
                startIndex +
                Number(itemsPerPage)
            );


    /* =========================================
       Search Handler
    ========================================= */

    const handleSearch = (e) => {

        setSearchTerm(
            e.target.value
        );

        setCurrentPage(1);

    };


    /* =========================================
       Items Per Page Handler
    ========================================= */

    const handleItemsPerPage = (e) => {

        setItemsPerPage(
            e.target.value
        );

        setCurrentPage(1);

    };


    /* =========================================
       Page Handler
    ========================================= */

    const goToPage = (page) => {

        if (
            page >= 1 &&
            page <= totalPages
        ) {

            setCurrentPage(page);

        }

    };


    /* =========================================
       Clear Search
    ========================================= */

    const clearSearch = () => {

        setSearchTerm('');

        setCurrentPage(1);

    };


    return (

        <div className="all-user-data-container">

            <div className="user-data-content-wrapper">

             

                {/* =====================================
                    SUMMARY CARDS
                ===================================== */}

                <div
                    className="stats-overview-grid"
                    style={{
                        display: 'grid',
                        gridTemplateColumns:
                            'repeat(auto-fit, minmax(180px, 1fr))',
                        gap: '15px',
                        marginBottom: '25px',
                        marginTop: '15px'
                    }}
                >

                    {/* Total Messages */}

                    <div
                        className="stat-summary-card"
                        style={{
                            background: '#eef2ff',
                            borderLeft:
                                '5px solid #4f46e5',
                            padding: '15px',
                            borderRadius: '8px',
                            boxShadow:
                                '0 2px 4px rgba(0,0,0,0.05)'
                        }}
                    >

                        <h4
                            style={{
                                margin:
                                    '0 0 5px 0',
                                color: '#4f46e5',
                                fontSize: '14px',
                                textTransform:
                                    'uppercase'
                            }}
                        >
                            Total Messages
                        </h4>

                        <p
                            style={{
                                margin: 0,
                                fontSize: '24px',
                                fontWeight: 'bold',
                                color: '#1f2937'
                            }}
                        >
                            {messages
                                ? messages.length
                                : 0}
                        </p>

                    </div>


                    {/* Type Counts */}

                    {Object.keys(typeCounts).map(
                        (typeName) => (

                            <div
                                key={typeName}
                                className="stat-summary-card"
                                style={{
                                    background: '#fff',

                                    borderLeft:
                                        '5px solid #10b981',

                                    padding: '15px',

                                    borderRadius: '8px',

                                    boxShadow:
                                        '0 2px 4px rgba(0,0,0,0.05)',

                                    border:
                                        '1px solid #e5e7eb',

                                    borderLeftWidth: '5px'
                                }}
                            >

                                <h4
                                    style={{
                                        margin:
                                            '0 0 5px 0',

                                        color:
                                            '#4b5563',

                                        fontSize:
                                            '14px',

                                        textTransform:
                                            'capitalize'
                                    }}
                                >
                                    {typeName}
                                </h4>

                                <p
                                    style={{
                                        margin: 0,

                                        fontSize:
                                            '24px',

                                        fontWeight:
                                            'bold',

                                        color:
                                            '#111827'
                                    }}
                                >
                                    {
                                        typeCounts[
                                            typeName
                                        ]
                                    }
                                </p>

                            </div>

                        )
                    )}

                </div>


                {/* =====================================
                    MESSAGE TABLE CARD
                ===================================== */}

                <div className="user-data-card">

                    <h2 className="user-data-title">
                        All Student Messages
                    </h2>


                    {/* =================================
                        SEARCH + ITEMS PER PAGE
                    ================================= */}

                    <div className="user-table-controls">

                        {/* Search */}

                        <div className="user-search-box">

                            <input
                                type="text"

                                placeholder="Search ID, name, phone, email, type, subject, message..."

                                value={searchTerm}

                                onChange={
                                    handleSearch
                                }
                            />

                            {searchTerm && (

                                <button
                                    type="button"

                                    className="clear-search-btn"

                                    onClick={
                                        clearSearch
                                    }
                                >
                                    ×
                                </button>

                            )}

                        </div>


                        {/* Items Per Page */}

                        <div className="items-per-page">

                            <label htmlFor="itemsPerPage">
                                Show:
                            </label>

                            <select
                                id="itemsPerPage"

                                value={
                                    itemsPerPage
                                }

                                onChange={
                                    handleItemsPerPage
                                }
                            >

                                <option value="10">
                                    10
                                </option>

                                <option value="25">
                                    25
                                </option>

                                <option value="50">
                                    50
                                </option>

                                <option value="100">
                                    100
                                </option>

                                <option value="all">
                                    All
                                </option>

                            </select>

                            <span>
                                items
                            </span>

                        </div>

                    </div>


                    {/* =================================
                        STATISTICS
                    ================================= */}

                    <div className="user-data-stats">

                        <p>

                            Total Messages:{' '}

                            <strong>
                                {messages
                                    ? messages.length
                                    : 0}
                            </strong>

                        </p>


                        <p>

                            Search Result:{' '}

                            <strong>
                                {
                                    filteredMessages.length
                                }
                            </strong>

                        </p>

                    </div>


                    {/* =================================
                        TABLE
                    ================================= */}

                    <div className="table-responsive">

                        <table className="user-data-table">

                            <thead>

                                <tr>

                                    <th>
                                        #
                                    </th>

                                    <th>
                                        ID
                                    </th>

                                    <th>
                                        Name
                                    </th>

                                    <th>
                                        Phone
                                    </th>

                                    <th>
                                        Email
                                    </th>

                                    <th>
                                        Type
                                    </th>

                                    <th>
                                        Subject
                                    </th>

                                    <th>
                                        Message
                                    </th>

                                    <th>
                                        Date
                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                {displayedMessages.length >
                                    0 ? (

                                    displayedMessages.map(
                                        (
                                            item,
                                            index
                                        ) => (

                                            <tr
                                                key={
                                                    item.id ||
                                                    index
                                                }
                                            >

                                                {/* Serial */}

                                                <td>
                                                    {
                                                        startIndex +
                                                        index +
                                                        1
                                                    }
                                                </td>


                                                {/* ID */}

                                                <td>
                                                    {
                                                        item.id ||
                                                        'N/A'
                                                    }
                                                </td>


                                                {/* Name */}

                                                <td>
                                                    {
                                                        item.name ||
                                                        'N/A'
                                                    }
                                                </td>


                                                {/* Phone */}

                                                <td>
                                                    {
                                                        item.phone ||
                                                        'N/A'
                                                    }
                                                </td>


                                                {/* Email */}

                                                <td>
                                                    {
                                                        item.email ||
                                                        'N/A'
                                                    }
                                                </td>


                                                {/* Type */}

                                                <td>

                                                    <span className="type-badge">

                                                        {
                                                            item.type ||
                                                            'N/A'
                                                        }

                                                    </span>

                                                </td>


                                                {/* Subject */}

                                                <td>
                                                    {
                                                        item.subject ||
                                                        'N/A'
                                                    }
                                                </td>


                                                {/* Message */}

                                                <td>
                                                    {
                                                        item.message ||
                                                        'N/A'
                                                    }
                                                </td>


                                                {/* Date */}

                                                <td>
                                                    {
                                                        toIST(
                                                            item.date
                                                        )
                                                    }
                                                </td>

                                            </tr>

                                        )
                                    )

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="9"
                                            className="no-data-message"
                                        >
                                            {
                                                searchTerm
                                                    ? 'No messages found for this search'
                                                    : 'No messages found'
                                            }
                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>


                    {/* =================================
                        PAGINATION
                    ================================= */}

                    {itemsPerPage !== 'all' &&
                        filteredMessages.length >
                        0 && (

                            <div className="user-pagination">

                                <button
                                    onClick={() =>
                                        goToPage(
                                            currentPage -
                                            1
                                        )
                                    }

                                    disabled={
                                        currentPage ===
                                        1
                                    }
                                >
                                    ← Previous
                                </button>


                                <span>

                                    Page{' '}

                                    <strong>
                                        {
                                            currentPage
                                        }
                                    </strong>

                                    {' '}of{' '}

                                    <strong>
                                        {
                                            totalPages
                                        }
                                    </strong>

                                </span>


                                <button
                                    onClick={() =>
                                        goToPage(
                                            currentPage +
                                            1
                                        )
                                    }

                                    disabled={
                                        currentPage ===
                                        totalPages
                                    }
                                >
                                    Next →
                                </button>

                            </div>

                        )}


                    {/* =================================
                        BOTTOM INFORMATION
                    ================================= */}

                    <div className="user-data-stats">

                        <p>

                            Showing{' '}

                            <strong>

                                {
                                    filteredMessages.length ===
                                        0
                                        ? 0
                                        : startIndex +
                                        1
                                }

                            </strong>

                            {' '}to{' '}

                            <strong>

                                {
                                    Math.min(
                                        startIndex +
                                        displayedMessages.length,

                                        filteredMessages.length
                                    )
                                }

                            </strong>

                            {' '}of{' '}

                            <strong>

                                {
                                    filteredMessages.length
                                }

                            </strong>

                            {' '}messages

                        </p>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default StudentMessage;